
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class StepTracker extends Vue {
  @Prop({ default: 1 }) readonly step!: number;
  @Prop({ default: false }) readonly compact!: boolean;
}
